class PhoneInput {
    #element;

    constructor(element) {
        this.#element = element;

        this.render();
    }

    filterInput(event) {
        const input = event.target;
        const value = input.value;
        const filteredValue = value.replaceAll(/[^0-9+\s]/g, '');
        input.value = filteredValue;
    }

    render() {
        this.#element.addEventListener('input', this.filterInput);
    }
}

export default PhoneInput;
